import { useNavigate } from 'react-router-dom';
import { useReveal } from '@/hooks/useReveal';
import PageLoader from '@/components/PageLoader';
import HeroCrumbs from '@/components/HeroCrumbs';
import Button from '@/components/ui/Button';
import { CASE_POSTS } from '@/data/mockData';
// [2026-10-23 사용자] 제품 서브 화이트 전환(격리) — 화이트 전용 모듈. 다크 공유 모듈 보존(홈·InstallPages 안전).
import s from './ProductWhite.module.scss';   // 공통 제품상세 스타일(화이트)
import t from './ProductInstrumentsWhite.module.scss'; // buy/link 카드(화이트)
import { GUIDE_ICON } from '@/components/GuideIcons';
const Ic = ({ n }: { n: string }) => <div className={t.cardIcon}>{GUIDE_ICON[n]}</div>; // [2026-10-08] 다크 카드 시안 라인아이콘

// ============================================================================
//  제품 상세 — AI IoT 체감온도계  (/products/heat-index)
//  [2026-10-08] 기획서 v7 2-4. 10개 콘텐츠 영역 순서 + 반복 CTA.
//    실데이터: ①첫화면 ③현장기능 ④플랫폼 ⑤알림 ⑥사양 ⑦설치장면(안전 설치사례)  — mockData WBGT 실측(762-774)
//    준비중(회사 자료 대기): ②충전형 여부 ⑥KC 진행상태 ⑧요금제(가격) ⑨TV중계기
//    주의(기획서 block 126): '제품 사용만으로 법적의무 자동충족' 표현 금지 → '사업장 관리·기록 지원'으로 서술.
//  사양 출처: mockData GUIDE 안전 WBGT product.specs(검증본) 복제 + 근거 [[evs-safety-wbgt-product]].
// ============================================================================

const HERO_IMG = '/images/products/products-hero.webp'; // [2026-10-11] 제품 메뉴 히어로 이미지 통일(구 hero-safety에서 변경)
const WBGT_IMG = '/images/products/wbgt-crop-v2.png';
// [2026-10-11 사용자] 서브 슬로건 풍성화(문서 대표제목 2-4 핵심 유지+확장). 히어로 중앙 충분히 차게.
const SLOGAN = '현장 체감온도(WBGT)를 실시간 측정하고 위험단계를 자동 판정해, 작업자 알림·법정 기록·보고서까지 하나로 연결하는 AI IoT 체감온도계입니다.';

// 검증 사양(mockData 763-774). KC 진행상태는 별도(준비중).
const SPECS: { k: string; v: string }[] = [
  { k: '측정 항목', v: '체감온도(WBGT) · 기온 · 습도 실시간 산출' },
  { k: '센서 정확도', v: '±0.5℃ 이내 (초정밀 센서)' },
  { k: '전송 주기', v: '1분 주기 클라우드 전송' },
  { k: '위험 경보', v: '관심·주의·경고·위험 4단계 자동 판정' },
  { k: '알림', v: 'SMS · 앱푸시(FCM) · 이메일 · 카카오톡' },
  { k: '디스플레이', v: '4.3" TFT LCD · 480×272 · 262K색' },
  { k: '제어부', v: 'DWIN T5L0 ASIC · DGUS II · 8MB Flash' },
  { k: '밝기', v: '300nit LED 백라이트 (수명 20,000h↑)' },
  { k: '통신', v: 'WiFi · LTE · Ethernet (연결성 98%)' },
  { k: '동작 환경', v: '-20 ~ 70℃ · 습도 10~90%RH' },
  { k: '전원', v: 'DC 5V (정격 5W 이하)' },
  { k: '기록·관제', v: '법정기록 자동 저장 · SaaS 통합관제' },
];
const STAGES = [
  { n: '관심', t: '31℃', c: '#35c17e' }, { n: '주의', t: '33℃', c: '#e8b33a' },
  { n: '경고', t: '35℃', c: '#e8862f' }, { n: '위험', t: '38℃', c: '#e5484d' },
];
// [2026-10-23 사용자] ★제품 스펙 공통 스타일(웜 밴드+제원 리스트) — 사양 키→심플 라인 아이콘(미매칭=solution).
const SPEC_ICON: Record<string, string> = {
  '측정 항목': 'gauge', '센서 정확도': 'certified', '전송 주기': 'signal', '위험 경보': 'alert',
  '알림': 'bell', '디스플레이': 'monitor', '제어부': 'ai', '밝기': 'energy',
  '통신': 'signal', '동작 환경': 'gauge', '전원': 'energy', '기록·관제': 'database',
};
// [2026-10-23 사용자] ④ 플랫폼 연동 = 사이드 탭 카드(Claude Design 스펙). 색/구조 목표대로, 폰트·크기 사이트. 아이콘=스펙 제공 SVG.
const PLATFORM = [
  { tab: '1분', title: '1분 전송', desc: '측정값을 1분 주기로 클라우드에 전송해 실시간 관제합니다.',
    cTab: 'linear-gradient(180deg,#1E6BFF,#2A9DF4)', cTile: 'linear-gradient(135deg,#1E6BFF,#2A9DF4)', cGlow: '0 14px 26px -10px rgba(30,107,255,.6)',
    icon: (<svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="6" r="2" /><path d="M12 8v13" /><path d="M8.5 21 12 14l3.5 7" /><path d="M7.2 3.3a6.6 6.6 0 0 0 0 5.4" /><path d="M16.8 3.3a6.6 6.6 0 0 1 0 5.4" /></svg>) },
  { tab: '30분', title: '30분 기록', desc: '측정 이력을 주기적으로 기록해 법정기록으로 자동 저장합니다.',
    cTab: 'linear-gradient(180deg,#0891B2,#06A8C9)', cTile: 'linear-gradient(135deg,#0891B2,#22C5E0)', cGlow: '0 14px 26px -10px rgba(8,145,178,.6)',
    icon: (<svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="3.5" y="5" width="17" height="15.5" rx="2.5" /><path d="M3.5 10h17" /><path d="M8 3v4" /><path d="M16 3v4" /><rect x="10" y="13" width="4" height="4" rx=".6" /></svg>) },
  { tab: '14일', title: '14일 로컬 저장', desc: '통신 장애 시에도 단말 로컬에 데이터를 보존해 유실을 방지합니다.',
    cTab: 'linear-gradient(180deg,#6D4BFF,#9378FF)', cTile: 'linear-gradient(135deg,#6D4BFF,#A08BFF)', cGlow: '0 14px 26px -10px rgba(109,75,255,.6)',
    icon: (<svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><ellipse cx="12" cy="5.5" rx="7.5" ry="2.8" /><path d="M4.5 5.5v13c0 1.5 3.4 2.8 7.5 2.8s7.5-1.3 7.5-2.8v-13" /><path d="M4.5 12c0 1.5 3.4 2.8 7.5 2.8s7.5-1.3 7.5-2.8" /></svg>) },
];
// [2026-10-23 사용자] ⑤ 다채널 즉시 알림 = 화살표 띠(Claude Design 스펙). 에스컬레이션 블루 셰브론 + 하단 캡션. 아이콘=스펙 제공 SVG.
const ALERT_FLOW = [
  { n: '01', name: 'SMS', seg: '#8CC6F4',
    icon: (<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#0A4FAE" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"><path d="M4 5.5h16a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5H10l-4.5 3.5V17.5H4A1.5 1.5 0 0 1 2.5 16V7A1.5 1.5 0 0 1 4 5.5z" /><path d="M7 10h10" /><path d="M7 13.5h6" /></svg>) },
  { n: '02', name: '앱푸시(FCM)', seg: '#6FB8F2',
    icon: (<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"><rect x="6" y="2.5" width="10" height="19" rx="2" /><path d="M10 18.5h2" /><path d="M18.5 6.5a4 4 0 0 1 0 5" /><path d="M20.6 4.5a7 7 0 0 1 0 9" /></svg>) },
  { n: '03', name: '이메일', seg: '#2E86E6',
    icon: (<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"><rect x="2.5" y="5" width="19" height="14" rx="2" /><path d="m3.5 6.5 8.5 6.5 8.5-6.5" /></svg>) },
  { n: '04', name: '카카오톡', seg: '#0A5FD0',
    icon: (<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"><path d="M12 4C6.8 4 2.8 7.2 2.8 11.2c0 2.6 1.7 4.8 4.3 6.1L6.2 21l4-2.7c.6.1 1.2.1 1.8.1 5.2 0 9.2-3.2 9.2-7.2S17.2 4 12 4z" /><path d="M8.2 11.3h.01" /><path d="M12 11.3h.01" /><path d="M15.8 11.3h.01" /></svg>) },
  { n: '05', name: '전광판', seg: 'repeating-linear-gradient(135deg,#0C3577 0 10px,#0E3B84 10px 20px)', soon: true,
    icon: (<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#C9D8F2" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="2.4 2"><rect x="2.5" y="4" width="19" height="12.5" rx="1.5" /><path d="M12 16.5V20" /><path d="M8 20.5h8" /><path d="M6 8h7" /><path d="M6 11.5h4" /></svg>) },
];

const Reveal = ({ className = '', children }: { className?: string; children: React.ReactNode }) => {
  const ref = useReveal<HTMLDivElement>();
  return <div className={`${className} anim-scroll`} ref={ref}>{children}</div>;
};

function Soon({ label }: { label: string }) {
  return (
    <div className={s.soon} role="img" aria-label={`${label} 준비중`}>
      <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
      <span>{label} · 준비중</span>
    </div>
  );
}

export default function ProductHeatIndex() {
  const navigate = useNavigate();
  const nav = (to: string) => navigate(to);
  const safetyCases = CASE_POSTS.filter((p) => p.domain === 'safety').slice(0, 3);

  return (
    <main className={s.page}>
      <PageLoader />

      <header className={s.hero}>
        <div className={s.heroBg} style={{ backgroundImage: `url(${HERO_IMG})` }} />
        <div className={s.heroOverlay} />
        <HeroCrumbs items={['HOME', '제품', 'AI 체감온도계']} />
        <div className={s.heroInner}>
          <p className={s.heroEyebrow}>AI HEAT-INDEX IoT</p>
          <h1 className={s.heroTitle}>AI IoT 체감온도계</h1>
          <p className={s.heroSub}>{SLOGAN}</p>
        </div>
      </header>

      {/* ① 제품 첫 화면 */}
      <section className={s.section}>
        <Reveal className={s.first}>
          <div className={s.firstMedia}><img src={WBGT_IMG} alt="AI IoT 체감온도계" /></div>
          <div className={s.firstBody}>
            <span className={s.badge}>SaaS 통합관제</span>
            <h2 className={s.h2}>AI 온열질환 IoT 체감온도계</h2>
            <p className={s.lead}>현장 체감온도(WBGT)를 실시간 산출해 위험을 자동 경보하고 법정기록을 저장하는 IoT 단말입니다. 측정→분석→경보→대응→기록의 5단계를 자동화해 사업장의 온열질환 관리와 기록을 지원합니다.</p>
            <div className={s.chips}><span className={s.chip}><b>통신</b>WiFi·Ethernet·LTE</span><span className={s.chip}><b>정확도</b>±0.5℃</span></div>
            <div className={s.ctaRow}>
              <Button variant="pill" onClick={() => nav('/support/inquiry?product=' + encodeURIComponent('AI 체감온도계') + '&from=/products/heat-index')}>구매·견적</Button>
              <a className={s.ctaGhost} onClick={() => nav('/safety/platform')}>플랫폼 체험</a>
              <span className={`${s.ctaGhost} ${s.ctaSoon}`} aria-disabled>카탈로그 (준비중)</span>
            </div>
          </div>
        </Reveal>
      </section>

      {/* ② 제품 유형 */}
      <section className={`${s.section} ${s.alt}`}>
        <Reveal>
          <p className={s.eyebrow}>TYPE</p>
          <h2 className={s.h2c}>제품 유형 · 통신 방식</h2>
          <div className={t.buyGrid}>
            <div className={t.buyCard}><Ic n="energy" /><h3>설치형 (상시 전원)</h3><p>사업장 현장에 설치해 상시 전원(DC 5V)으로 운영하는 설치형 단말입니다. 고정 지점의 체감온도를 24시간 연속 관제합니다.</p></div>
            <div className={t.buyCard}><Ic n="signal" /><h3>통신 방식 선택</h3><p>Wi-Fi · Ethernet · LTE 중 현장 환경에 맞게 선택합니다. LTE는 유선망이 없는 야외·건설현장에 적합합니다.</p></div>
          </div>
          <p className={s.note}>※ 충전형(배터리) 옵션 제공 여부·설치형태 상세는 확정 후 반영합니다.</p>
        </Reveal>
      </section>

      {/* ③ 현장 기능 */}
      <section className={s.section}>
        <Reveal>
          <p className={s.eyebrow}>FIELD FUNCTION</p>
          <h2 className={s.h2c}>현장에서 하는 일</h2>
          <p className={s.sub}>기온·습도를 측정해 기상청 공식 산출식으로 체감온도(WBGT)를 실시간 계산하고, 위험단계를 자동 판정해 현장 화면·경보로 알립니다.</p>
          {/* [2026-10-23 사용자] ★핵심=위험 4단계 임계 체감온도 → 에스컬레이션 컬러 카드로 강조(큰 온도 숫자) */}
          <div className={s.riskScale}>
            {STAGES.map((st) => (
              <div key={st.n} className={s.riskCard} style={{ ['--rc' as string]: st.c } as React.CSSProperties}>
                <span className={s.riskName}>{st.n}</span>
                <span className={s.riskTemp}>{st.t}</span>
                <span className={s.riskHint}>이상</span>
              </div>
            ))}
          </div>
          <p className={s.note}>※ 체감온도(WBGT) 기준 4단계 자동 판정 · 단계가 올라갈수록 경보·행동요령이 강화됩니다.</p>
        </Reveal>
      </section>

      {/* ④ 플랫폼 연동 — [2026-10-23 사용자] 사이드 탭 카드(Claude Design 스펙, 색/구조 목표대로·폰트 사이트) */}
      <section className={`${s.section} ${s.sideBand}`}>
        <span className={s.sideWatermark} aria-hidden>24/7</span>
        <Reveal>
          <p className={s.eyebrow}>PLATFORM</p>
          <h2 className={s.h2c}>통합 관제 플랫폼 연동</h2>
          <div className={s.sideGrid}>
            {PLATFORM.map((c) => (
              <div key={c.tab} className={s.sideItem}>
                {/* [2026-10-23 사용자] 탭 세로글자 제거(거꾸로 보임 + 카드 제목과 중복). 컬러 탭만 유지. */}
                <div className={s.sideTab} style={{ ['--tab' as string]: c.cTab } as React.CSSProperties} />
                <div className={s.sideCard}>
                  <span className={s.sideIco} style={{ ['--tile' as string]: c.cTile, ['--glow' as string]: c.cGlow } as React.CSSProperties}>{c.icon}</span>
                  <h3>{c.title}</h3>
                  <p>{c.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <a className={s.sideBtn} onClick={() => nav('/safety/platform')}>통합 관제 SaaS 보기 →</a>
        </Reveal>
      </section>

      {/* ⑤ 다채널 즉시 알림 — [2026-10-23 사용자] 화살표 띠(Claude Design 스펙). 중앙정렬·제목 위/ALERT 아래·에스컬레이션 블루. */}
      <section className={`${s.section} ${s.alertBand}`}>
        <Reveal>
          <h2 className={s.alertTitle}>다채널 즉시 알림</h2>
          <p className={s.alertEyebrow}>ALERT</p>
          <p className={s.alertDesc}>위험 단계 도달 시 담당자에게 다채널로 즉시 알립니다. 현장 전광판 표시는 TV·모니터 중계기와 연계해 제공 예정입니다.</p>
          <div className={s.alertFlow}>
            {ALERT_FLOW.map((c) => (
              <div key={c.n} className={s.alertSeg} style={{ ['--seg' as string]: c.seg } as React.CSSProperties}>{c.icon}</div>
            ))}
          </div>
          <div className={s.alertCaps}>
            {ALERT_FLOW.map((c) => (
              <div key={c.n} className={s.alertCap}>
                <div className={s.alertCapNum} style={c.soon ? { color: '#6B7684' } : undefined}>{c.n}</div>
                <div className={s.alertCapName} style={c.soon ? { color: '#5C6773' } : undefined}>
                  {c.name}{c.soon && <span className={s.alertBadge}>예정</span>}
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </section>

      {/* ⑥ 인증·사양 — [2026-10-23 사용자] ★제품 스펙 공통 스타일: 전폭 웜 밴드 + 제원 리스트 */}
      <section className={`${s.section} ${s.specBand}`}>
        <Reveal>
          <p className={s.eyebrow}>SPEC & CERT</p>
          <h2 className={s.h2c}>인증 · 사양</h2>
          <div className={s.specList}>
            {SPECS.map((sp, i) => (
              <div key={i} className={s.specRow}>
                <div className={s.specIco}>{GUIDE_ICON[SPEC_ICON[sp.k] || 'solution']}</div>
                <span className={s.specKey}>{sp.k}</span>
                <span className={s.specVal}>{sp.v}</span>
              </div>
            ))}
          </div>
          <p className={s.note}>※ KC 인증 진행상태·배터리 사양은 확정 후 게시합니다.</p>
        </Reveal>
      </section>

      {/* ⑦ 설치·사용장면 */}
      <section className={s.section}>
        <Reveal>
          <p className={s.eyebrow}>IN THE FIELD</p>
          <h2 className={s.h2c}>건설현장 · 제조공장 · 야외작업장</h2>
          <p className={s.sub}>옥외·고온·다수 공정·교대작업 현장에서 체감온도를 실시간 관제합니다. 실제 도입 현장을 확인하세요.</p>
          <div className={s.caseGrid}>
            {safetyCases.map((c) => (
              <a key={c.slug} className={s.caseCard} onClick={() => nav(`/cases/${c.slug}`)}>
                <div className={s.caseImg}><img src={c.cover} alt={c.title} loading="lazy" /></div>
                <strong>{c.title}</strong><em>{c.date}</em>
              </a>
            ))}
          </div>
          <a className={s.moreLink} onClick={() => nav('/cases?tab=safety')}>안전 설치사례 전체 보기 →</a>
        </Reveal>
      </section>

      {/* ⑧ 요금제 */}
      <section className={`${s.section} ${s.alt}`}>
        <Reveal>
          <p className={s.eyebrow}>PRICING</p>
          <h2 className={s.h2c}>요금제</h2>
          <p className={s.sub}>단말 가격, 통신 방식, Pro·AI 요금제, LTE 통신 비용의 공개 범위를 이 영역에 안내합니다.</p>
          <Soon label="요금제·단말 가격" />
        </Reveal>
      </section>

      {/* ⑨ 연관 제품 */}
      <section className={s.section}>
        <Reveal>
          <p className={s.eyebrow}>RELATED</p>
          <h2 className={s.h2c}>연관 제품</h2>
          <a className={t.linkCard} onClick={() => nav('/safety/platform')}>
            <div style={{ width: 76, height: 76, display: 'grid', placeItems: 'center', background: 'rgba(0,174,239,.1)', borderRadius: 10, color: '#00AEEF', flex: '0 0 auto' }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><rect x="3" y="4" width="18" height="13" rx="1.5" /><path d="M8 20h8M12 17v3" /></svg>
            </div>
            <div><strong>체감온도 통합관제 SaaS</strong><em>여러 현장의 체감온도·위험상태를 한 화면에서 관제</em></div>
            <span>→</span>
          </a>
          <div className={t.buyGrid} style={{ marginTop: 16 }}>
            <a className={t.buyCard} style={{ cursor: 'pointer' }} onClick={() => nav('/products/display-repeater')}><h3>TV·모니터 중계기 (개발 중) →</h3><p>체감온도·위험단계를 현장 TV·모니터에 크게 표시하는 중계기. 자세히 보기.</p></a>
            <div className={t.buyCard}><h3>현장 전광판 (예정)</h3><p>작업자 공동 확인용 전광판 표시를 중계기와 연계해 제공할 예정입니다.</p></div>
          </div>
        </Reveal>
      </section>

      {/* ⑩ 최종 행동 */}
      <section className={`${s.section} ${s.finalCta}`}>
        <Reveal>
          <h2 className={s.h2c}>현장 온열질환, 지금 대비하세요</h2>
          <p className={s.sub}>구매·견적, 플랫폼 체험으로 바로 연결됩니다. 카탈로그는 준비되는 대로 제공됩니다.</p>
          <div className={s.ctaRow}>
            <Button variant="pill" onClick={() => nav('/support/inquiry?product=' + encodeURIComponent('AI 체감온도계') + '&from=/products/heat-index')}>구매·견적</Button>
            <a className={s.ctaGhost} onClick={() => nav('/safety/platform')}>플랫폼 체험</a>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
